import React, { useState } from 'react'
import Logo from '../assets/images/goodlife_logo.jpeg'
import { Link } from 'react-router-dom';
import ReorderIcon from '@mui/icons-material/Reorder';
import '../styles/Navbar.css';

function Navbar() {
  const [openLinks, setOpenLinks] = useState(false);

  const toggleNavbar = () => {
    setOpenLinks(!openLinks)
  };

  return (
    <div className='navbar'>
        <div className='leftSide' id={openLinks ? 'open' : 'close'}>
            <img src={Logo} alt="Signs of the Good Life Logo" />
            <h1>Signs of the Good Life</h1>
            <div className='hiddenLinks'>
                <Link to="/">Home</Link>
                <Link to="/collection">Collection</Link>
                <Link to="/featured-collection">Featured</Link>
                <Link to="/about">About</Link>                
                <Link to="/contact">Contact Me</Link>
            </div>     
        </div>
      
      <div className='rightSide'>
        <Link to="/">Home</Link>
        <Link to="/collection">Collection</Link>
        <Link to="/featured-collection">Featured</Link>
        <Link to="/about">About</Link>        
        <Link to="/contact">Contact Me</Link>
        <button onClick={toggleNavbar}>
            <ReorderIcon />
        </button>
      </div>
    </div>
  )
}

export default Navbar
